import React, { useEffect } from 'react';
import Highcharts from 'highcharts';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const HighchartSkill = ({ data }) => {
  useEffect(() => {
    Highcharts.chart(`container-${data.habilidade_id}`, {
      chart: {
        type: 'pie',
        backgroundColor: 'none',
        height: '250',
        width: '200'
      },
      title: {
        text: ''
      },
      subtitle: {
        text: `${data.qtd}/${data.qtd_total}<br>Acertos`,
        align: 'center',
        verticalAlign: 'center',
        style: {
          fontSize: '35px',
          textAlign: 'center'
        },
        x: 0,
        y: 100
      },
      plotOptions: {
        pie: {
          shadow: false,
          center: ['50%', '50%'],
          dataLabels: {
            enabled: false
          },
          states: {
            hover: {
              enabled: false
            }
          },
          size: 100,
          innerSize: '100%',
          borderColor: null,
          borderWidth: 8
        }
      },
      tooltip: {
        valueSuffix: '%',
        valueDecimals: 2
      },
      series: [
        {
          size: '100%',
          innerSize: '100%',
          data: [
            {
              name: 'erros',
              y: 100 * (1 - data.qtd / data.qtd_total),
              color: '#cccc'
            },
            {
              name: 'acertos',
              y: (100 * data.qtd) / data.qtd_total,
              color: '#48ab86'
            }
          ]
        }
      ]
    });
  });

  return (
    <div
      id={`container-${data.habilidade_id}`}
      style={{ overflow: 'scroll' }}
    ></div>
  );
};

export default HighchartSkill;
